export default {
  models: {
    name: {
      acs_server: {
        one: 'ACS Server',
        other: 'ACS Servers',
        gender: 'male'
      },
      address: {
        one: 'IP Address',
        other: 'IP Addresses'
      },
      agent: {
        one: 'Box',
        other: 'Box'
      },
      alert: {
        one: 'Alert',
        other: 'Alerts'
      },
      audit: {
        one: 'Audit',
        other: 'Audits'
      },
      automigrator: {
        one: 'Automigrator',
        other: 'Automigrators'
      },
      bmu_interfaces: {
        one: 'BMU Interface',
        other: 'BMU Interfaces'
      },
      bmus: {
        one: 'BMU',
        other: 'BMUs',
        interface: {
          one: 'Interce',
          other: 'Interfaces'
        }
      },
      changelog: {
        one: 'Changelog',
        other: 'Changelogs'
      },
      client: {
        one: 'Client',
        other: 'Clients'
      },
      cloud_license: {
        acs: {
          one: 'ACS License',
          other: 'ACS Licenses'
        },
        hola_suite: {
          one: 'Hola Suite License',
          other: 'Hola Suite Licenses'
        },
        one: 'Cloud License',
        other: 'Cloud Licenses'
      },
      contract: {
        one: 'Contract',
        other: 'Contracts'
      },
      conciliation: {
        one: 'Conciliation',
        other: 'Conciliations',
        gender: 'male'
      },
      coverage: {
        one: 'Coverage',
        other: 'Coverages'
      },
      dashboard: {
        one: 'Dashboard',
        other: 'Dashboards'
      },
      dhcp_server: {
        one: 'DHCP Server',
        other: 'DHCP Servers'
      },
      employee: {
        one: 'Employee',
        other: 'Employees'
      },
      fiber_configuration: {
        one: 'Fiber Configuration',
        other: 'Fiber Configurations'
      },
      gps_point: {
        one: 'Gps point',
        other: 'Gps points'
      },
      helpdesk: {
        issue: {
          one: 'Issue',
          other: 'Issues'
        },
        issue_category: {
          one: 'Category',
          other: 'Categories'
        },
        issue_comment: {
          one: 'Comment',
          other: 'Comments'
        }
      },
      hola_notification: {
        one: 'Notification',
        other: 'Notifications'
      },
      installation_order: {
        one: 'Installation order',
        other: 'Installation orders'
      },
      installation_order_configuration: {
        one: 'Installation order configuration',
        other: 'Installation order configurations'
      },
      inventory: {
        article: {
          one: 'Article',
          other: 'Articles'
        },
        dealer: {
          one: 'Dealer',
          other: 'Dealers'
        },
        movement: {
          one: 'Movement',
          other: 'Movements'
        },
        stock: {
          one: 'Stock',
          other: 'Stocks'
        },
        subscription: {
          one: 'Subscription',
          other: 'Subscriptions'
        },
        warehouse: {
          one: 'Warehouse',
          other: 'Warehouses'
        }
      },
      invoices: {
        one: 'Invoice',
        other: 'Invoices'
      },
      invoicing: {
        abstract_invoice: {
          one: 'Invoice / Credit Note',
          other: 'Invoices / Credit Notes'
        },
        cash_audit: {
          one: 'Cash audit',
          other: 'Cash audits'
        },
        cash_audit_transaction: {
          one: 'Cash audit',
          other: 'Cash audits'
        },
        categories: {
          one: 'Category',
          other: 'Categories'
        },
        clients_payment_gateway: {
          one: 'Payment Gateway',
          other: 'Payment Gateways'
        },
        contract_discount: {
          one: 'Discount',
          other: 'Discounts'
        },
        credit_note: {
          one: 'Credit Note',
          other: 'Credit Notes'
        },
        credit_note_pool_number: {
          one: 'Credit Notes numeration',
          other: 'Credit Notes numeration'
        },
        current_account: {
          one: 'Current acount',
          other: 'Current accounts'
        },
        discount: {
          one: 'Discount',
          other: 'Discounts'
        },
        invoice: {
          one: 'Invoice',
          other: 'Invoices'
        },
        invoice_item: {
          one: 'Item',
          other: 'Items'
        },
        invoice_item_kind: {
          one: 'Item kind',
          other: 'Item kinds'
        },
        invoice_pool_number: {
          one: 'DIAN authorized numeration',
          other: 'DIAN authorized numeration'
        },
        invoicing_firm: {
          one: 'Invoicing Firm',
          other: 'Invoicing Firms'
        },
        invoicing_configuration: {
          one: 'Configuration',
          other: 'Configurations'
        },
        payment: {
          one: 'Payment',
          other: 'Payments'
        },
        payment_gateway: {
          one: 'Payment gateway',
          other: 'Payment gateways',

          vippo: {
            transaction_report: {
              one: 'Transaction Report',
              other: 'Transaction Reports'
            }
          }
        },
        payment_promise: {
          one: 'Payment promise',
          other: 'Payment promises'
        },
        payment_receipt: {
          one: 'Payment Receipt',
          other: 'Payment Receipts'
        },
        profile: {
          one: 'Profile',
          other: 'Profiles'
        },
        recurring_item: {
          one: 'Recurring Item',
          other: 'Recurring Items'
        },
        tax: {
          one: 'Tax',
          other: 'Taxs'
        },
        transaction_kind: {
          one: 'Payment kind',
          other: 'Payment kinds'
        }
      },
      invoicing_firm: {
        one: 'Invoicing Firm',
        other: 'Invoicing Firms'
      },
      invoicing_payment: {
        one: 'Payment',
        other: 'Payments'
      },
      isp: {
        one: 'Isp',
        other: 'Isps'
      },
      map: {
        one: 'Map',
        other: 'Maps'
      },
      mikrotik: {
        one: 'Mikrotik',
        other: 'Mikrotiks',
        interface: {
          one: 'Interface',
          other: 'Interfaces'
        }
      },
      nap: {
        one: 'NAP',
        other: 'NAPs'
      },
      nap_port: {
        one: 'NAP Port',
        other: 'NAP Ports'
      },
      nas: { one: 'NAS', other: 'NAS' },
      neighborhood: {
        one: 'Neighborhood',
        other: 'Neighborhoods'
      },
      olt_server_interfaces: {
        one: 'Network',
        other: 'Networks'
      },
      new: {
        one: 'New',
        other: 'News'
      },
      node: {
        one: 'Node',
        other: 'Nodes'
      },
      notification_mail: {
        one: 'Mail Notification',
        other: 'Mail Notifications'
      },
      notification_mobile: {
        one: 'Notification Mobile',
        other: 'Notifications Mobile'
      },
      notification_sms: {
        one: 'SMS Notification',
        other: 'SMS Notifications'
      },
      notification_web: {
        one: 'Web notification',
        other: 'Web Notifications'
      },
      notifications: {
        one: 'Notification',
        other: 'Notifications'
      },
      mikrotik_interfaces: {
        one: 'Mikrotik Interface',
        other: ' Mikrotik Interfaces'
      },
      olt: {
        one: 'OLT',
        other: 'OLTs',
        uplink_interfaces: {
          one: 'Uplink Interface',
          other: 'Uplink Interfaces'
        }
      },
      ont: {
        one: 'ONT',
        other: 'ONTs'
      },
      onu: {
        one: 'ONU',
        other: 'ONUs'
      },
      orders: {
        feedback: {
          one: 'Feedback',
          other: 'Feedbacks'
        },
        feedback_kind: {
          one: 'Feedback Kind',
          other: 'Feedback Kinds'
        },
        order: {
          one: 'Order',
          other: 'Orders'
        },
        order_configuration: {
          one: 'Order Configuration',
          other: 'Order Configurations'
        },
        parameter: {
          one: 'Parameter',
          other: 'Parameters'
        }
      },
      payment_promise: {
        one: 'Payment Promise',
        other: 'Payment Promises'
      },
      payment_receipt: {
        one: 'Payment Receipt',
        other: 'Payment Receipts'
      },
      plan: {
        one: 'Plan',
        other: 'Plans'
      },
      portal_configuration: {
        one: 'Portal Configuration',
        other: 'Portal Configurations'
      },
      ppp_profile: {
        one: 'PPP Profile',
        other: 'PPP Profiles'
      },
      preselection: {
        other: 'Pre Selection'
      },
      provider: {
        one: 'Provider',
        other: 'Providers'
      },
      push_notification: {
        one: 'Push Notification',
        other: 'Push Notifications'
      },
      record: {
        one: 'Record',
        other: 'Records'
      },
      referral: {
        credited_payment: {
          one: 'credited payment',
          other: 'credited payments'
        },
        payment: {
          one: 'Payment',
          other: 'Payments'
        },
        transaction: {
          one: 'Transaction',
          other: 'Transactions'
        }
      },
      sale_desk: {
        lead: {
          gender: 'male',
          one: 'Lead',
          other: 'Leads'
        },
        prospect: {
          gender: 'male',
          one: 'Prospect',
          other: 'Prospects'
        },
        source: {
          gender: 'male',
          one: 'Source',
          other: 'Sources'
        },
        tags: {
          gender: 'male',
          one: 'Tag',
          other: 'Tags'
        },
        ticket: {
          gender: 'male',
          one: 'Ticket',
          other: 'Tickets'
        },
        contact: {
          gender: 'male',
          one: 'Contact',
          other: 'Contacts'
        }
      },
      seal: {
        one: 'Seal',
        other: 'Seals'
      },
      sent_sms: {
        one: 'Sent SMS',
        other: 'Sent SMSes'
      },
      server_configuration: {
        one: 'Server',
        other: 'Servers'
      },
      smtp_configuration: {
        one: 'Smtp Configuration',
        other: 'Smtp Configurations'
      },
      template: {
        one: 'Template',
        other: 'Templates'
      },
      template_hola: {
        one: 'Template Hola',
        other: 'Templates Hola'
      },
      transaction: {
        one: 'Transaction',
        other: 'Transactions'
      },
      tv_service: {
        one: 'TV Service',
        other: 'TV Services',

        directv_go: {
          subscription: {
            one: 'Subscription',
            other: 'Subscriptions'
          },
          pack: {
            one: 'Pack',
            other: 'Packs'
          }
        }
      },
      zone: {
        one: 'Zone',
        other: 'Zones'
      }
    }
  }
};
